import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import activityAndAccommodationReducer from 'reducers/activityAndAccommodation';
import userSettingsReducer from 'reducers/userSettings';
import businessOwnerReducer from './businessOwner';

const rootReducer = combineReducers({
  form: formReducer,
  activityAndAccommodation: activityAndAccommodationReducer,
  userSettings: userSettingsReducer,
  businessOwner: businessOwnerReducer
});

export default rootReducer;
